<template>
  <section class="about-section section-padding"  > 

    <h2>
  <svg
    v-if="vars.isVisibleBool"
    width="1em"
    height="52"
    viewBox="0 0 41 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="flex-shrink-0"
    style="display: inline;"
  >
    <rect width="40.9678" height="40.9678" fill="#E4002B"/>
    <circle cx="12.7821" cy="4.69764"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="4.69764"  r="2.18495" fill="white"/>
    <circle cx="36.161"  cy="9.94151"  r="2.18495" fill="white"/>
    <circle cx="20.6478" cy="9.94151"  r="2.18495" fill="white"/>
    <circle cx="5.13465" cy="9.94151"  r="2.18495" fill="white"/>
    <circle cx="12.7821" cy="15.2946"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="15.2946"  r="2.18495" fill="white"/>
    <circle cx="36.161"  cy="20.5385"  r="2.18495" fill="white"/>
    <circle cx="20.6478" cy="20.5385"  r="2.18495" fill="white"/>
    <circle cx="5.13465" cy="20.5385"  r="2.18495" fill="white"/>
    <circle cx="12.7821" cy="25.8916"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="25.8916"  r="2.18495" fill="white"/>
    <circle cx="36.161"  cy="31.1355"  r="2.18495" fill="white"/>
    <circle cx="20.6478" cy="31.1355"  r="2.18495" fill="white"/>
    <circle cx="5.13465" cy="31.1355"  r="2.18495" fill="white"/>
    <circle cx="12.7821" cy="36.4886"  r="2.18495" fill="white"/>
    <circle cx="28.5136" cy="36.4886"  r="2.18495" fill="white"/>
  </svg><span v-if="vars.isVisibleBool">&nbsp;</span>{{ vars.titleText }}
</h2> 
 <div class="history-section section-padding pt-60 pb-60">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-xl-4 col-lg-4 col-md-6">
                    <div class="single-history-item">
                        <div class="history-img">
                            <LibraryImage :src="vars.photoImage" alt=""/>
                        </div>                         
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6">
                    <div class="single-history-item">
                        <div class="content-wrap">
                            <h5 class="!tw-text-black">{{ vars.titleOneText }}</h5>
                            <p>{{ vars.yearOneText }}</p>
                        <p >{{ vars.descOneText }}
                        </p>
                        </div>                        
                    </div>
                </div>
                
                <div class="col-xl-4 col-lg-4 col-md-6">
                    <div class="single-history-item">
                        <div class="history-img d-none d-lg-block">
                            <LibraryImage :src="vars.thirdImage" alt=""/>
                        </div>                        
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="timeline-wrap">
                </div>
            </div>

            <div class="row mt-120 align-items-center">
                <div class="col-xl-4 col-lg-4 col-md-6 order-2">
                    <div class="single-history-item">
                        <div class="  content-wrap">
                           <h5 class="!tw-text-black">{{ vars.titleTwoText }}</h5>
                            <p  >{{ vars.yearTwoText }}</p>
                        <p >{{ vars.descTwoText }}
                        </p>
                        </div>
                            
                    </div>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-6 order-1 order-xl-2">
                    <div class="single-history-item">
                        <div class="history-img">
                         <LibraryImage :src="vars.secondImage" alt=""/>
                        </div>
                    </div>
                </div>

                
                
                <div class="col-xl-4 col-lg-4 col-md-6 order-4">
                    <div class="single-history-item">
                        <div class="content-wrap">
                           <h5 class="!tw-text-black">{{ vars.titleThreeText }}</h5>
                            <p >{{ vars.yearThreeText }}</p>
                        <p>{{ vars.descThreeText }}
                        </p>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
        
</section>

</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  mixins: [ComponentMixin],

  data() {
    return {

  
      
    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    items() {
      return this.groupedVariables.items;
    },
  },

  methods: {
    isExternalLink(url: string) {
      return url.includes('http');
    },
  },
});
</script>
